<template>
  <div
    class="book_surgery toggleContainer desk_inner_width"
    :class="{ active: isOpen }"
    ref="past_diagnosis"
  >
    <a
      class="book_surgery_top flex"
      href="javascript:void(0)"
      @click.prevent="isOpen = !isOpen"
    >
      <span class="title flex is--fit desk-flex--start">
        <span class="flex flex--start is--fit">
          <span>אבחנות רקע*</span>
          <span
            v-if="!isAnesthesiaIndicationRequired"
            class="surgery-check flex"
            :class="{ active: isHealthy }"
            @click.stop="onHealthy"
          >
            <span class="surgery-check-ic block"></span>
            בריא בדרך כלל
          </span>
        </span>

        <Tags :isDoctor="true" :isRequired="true" />
      </span>

      <span class="plus-wrap flex m-flex--center">
        <span class="plus"></span>
      </span>
    </a>
    <div
      v-show="isOpen"
      class="book_surgery_open toggleInner"
      :class="{ 'section-disabled': isHealthy }"
    >
      <div class="no_mobile surg_list_head desk-flex">
        <div class="surg_list-1">צד</div>
        <div class="surg_list-3">שם אבחנה (ניתן לחפש לפי קוד)*</div>
        <div class="surg_list-3">קוד אבחנה</div>
        <div class="surg_list-5">הערות</div>
      </div>
      <PastDiagnosisInfo
        :rows="surgery.past_diagnosis"
        @editSelectedBlock="editSelectedBlock"
        @removeSelectedBlock="removeSelectedBlock"
      />
      <div
        class="surg_list_body inner_group bg--white desk-no-pad desk-flex desk-flex--top"
      >
        <div class="add_new_row flex surg_list-1">
          <div class="add_new_row_col1 desk-hide">צד</div>
          <div class="add_new_row_col2">
            <div class="input-opacity desk-block">
              <select2 name="" dir="rtl" v-model="past_diagnosis.side">
                <option value="">בחר צד</option>
                <option value="Right">Right</option>
                <option value="BIL">BIL</option>
                <option value="Left">Left</option>
              </select2>
            </div>
          </div>
        </div>
        <div class="add_new_row flex surg_list-3">
          <div class="add_new_row_col1 desk-hide">
            שם אבחנה*
            <span class="note block">ניתן לחפש לפי קוד</span>
          </div>
          <div class="add_new_row_col2">
            <div class="input-opacity desk-block relative">
              <div
                v-show="past_diagnosis.diagnosis_name !== ''"
                @click="past_diagnosis.diagnosis_name = ''"
                class="surg-clear-btn"
                :class="{ 'btn-mobile': isMobile }"
              >
                X
              </div>
              <multiselect
                placeholder=""
                v-model="past_diagnosis.diagnosis_name"
                @search-change="onSearch"
                @close="onSearch('')"
                :options="filteredTypeheadOptions"
                :searchable="true"
                :internal-search="false"
                :allow-empty="false"
                :options-limit="limit"
              ></multiselect>
            </div>
          </div>
        </div>
        <div class="add_new_row flex surg_list-3">
          <div class="add_new_row_col1 desk-hide">קוד אבחנה</div>
          <div class="add_new_row_col2">
            <div class="input-opacity desk-block">
              <input disabled v-model="past_diagnosis.diagnosis_number" />
            </div>
          </div>
        </div>
        <div class="add_new_row flex surg_list-5">
          <div class="add_new_row_col1 w-100 desk-hide">הערות</div>
          <div class="input_area_opcity">
            <textarea
              v-model="past_diagnosis.notice"
              placeholder="פירוט..."
              autocomplete="off"
            ></textarea>
          </div>
        </div>
        <ActionsMsgRow
          :errMsg="{ show: showErrorMessage, msg: errorMessage }"
          :isOnEdit="past_diagnosis_edit"
          @addBlock="addBlock"
          @removeSelectedBlock="resetRow"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations, mapGetters } from "vuex";
import Tags from "@/components/Dashboard/Surgery/AddSurgery/Steps/SurgeryDetails/modules/Tags.vue";
import PastDiagnosisInfo from "@/components/Dashboard/Surgery/AddSurgery/Steps/SurgeryDetails/info/PastDiagnosisInfo.vue";
import ActionsMsgRow from "@/components/Dashboard/Surgery/AddSurgery/Steps/SurgeryDetails/modules/ActionsMsgRow.vue";
import Multiselect from "vue-multiselect";
import "vue-multiselect/dist/vue-multiselect.min.css";
import typeheadSearch from "@/mixins/typehead-search.js";
import { DEFAULT_OPTIONS_LIMIT } from "@/utilities/typehead-search.js";

// Constants
const MOBILE_BREAKPOINT = 1200;

/**
 * PastDiagnosis Component
 * Handles the background diagnosis section for surgery
 * Includes "healthy" checkbox option to skip diagnosis entry
 */
export default {
  name: "PastDiagnosis",
  components: {
    Tags,
    PastDiagnosisInfo,
    ActionsMsgRow,
    Multiselect
  },
  mixins: [typeheadSearch],
  data() {
    return {
      isOpen: true,
      isMobile: window.innerWidth < MOBILE_BREAKPOINT,
      // Typeahead options for diagnosis
      past_diagnosis_options: [],
      doctorHistory: null,
      // Current form data
      past_diagnosis: {
        side: "",
        diagnosis_number: "",
        diagnosis_name: "",
        notice: ""
      },
      // Error messages
      errorMessage: "יש למלא את כל השדות",
      showErrorMessage: false,
      // Edit state
      past_diagnosis_edit: false,
      editRow: null
    };
  },
  computed: {
    ...mapState("Surgery", {
      surgery: state => state.surgery,
      isEditMode: state => state.isEditMode
    }),
    ...mapGetters(["activeDoctor"]),
    ...mapGetters("Surgery", ["isAnesthesiaIndicationRequired"]),

    /**
     * Checks if patient is marked as "healthy" (no background diagnoses needed)
     */
    isHealthy() {
      return this.surgery.background_diagnosis === "healthy";
    },

    /** Full options list searched by the typehead mixin */
    typeheadOptions() {
      return this.past_diagnosis_options;
    }
  },
  methods: {
    ...mapMutations("Surgery", ["SET_SURGERY"]),

    /**
     * Toggles the "healthy" status - when checked, no diagnoses are required
     */
    onHealthy() {
      if (this.isHealthy) {
        this.SET_SURGERY({ background_diagnosis: "" });
      } else {
        this.SET_SURGERY({ background_diagnosis: "healthy" });
        // Clear the past diagnosis array when marking as healthy
        this.SET_SURGERY({ past_diagnosis: [] });
        this.clearForm();
      }
    },

    /**
     * Moves a diagnosis row into edit mode
     */
    editSelectedBlock(index) {
      this.editRow = index;
      const object = { ...this.surgery.past_diagnosis[index] };
      const updatedDiagnosis = [...this.surgery.past_diagnosis];
      updatedDiagnosis.splice(index, 1);
      this.SET_SURGERY({ past_diagnosis: updatedDiagnosis });
      this.past_diagnosis = object;
      this.past_diagnosis_edit = true;
    },

    /**
     * Removes a diagnosis row from the list
     */
    removeSelectedBlock(index) {
      // Adjust edit index if removing a row before the currently edited row
      if (this.editRow !== null && index < this.editRow) {
        this.editRow--;
      }
      const updatedDiagnosis = [...this.surgery.past_diagnosis];
      updatedDiagnosis.splice(index, 1);
      this.SET_SURGERY({ past_diagnosis: updatedDiagnosis });
    },

    /**
     * Validates diagnosis data has required fields
     */
    validateObjectData(object) {
      return Boolean(object.diagnosis_name);
    },

    /**
     * Shows/hides the error message
     * Called from parent component during validation
     */
    setError(show) {
      this.showErrorMessage = show;
      if (show) this.isOpen = true;
    },

    /**
     * Validates and adds the current diagnosis to the list
     */
    addBlock() {
      const isAddFromEdit = this.editRow !== null;
      this.showErrorMessage = false;
      this.past_diagnosis_edit = false;

      const object = { ...this.past_diagnosis };
      if (!this.validateObjectData(object)) {
        this.showErrorMessage = true;
        if (isAddFromEdit) this.editRow = null;
        return;
      }

      // Deep clone to avoid mutating store directly
      const updated = this.surgery.past_diagnosis.map(d => ({ ...d }));

      if (isAddFromEdit && this.editRow !== null) {
        updated.splice(this.editRow, 0, object);
      } else {
        updated.push(object);
      }

      this.SET_SURGERY({ past_diagnosis: updated });
      this.clearForm();
      if (isAddFromEdit) this.editRow = null;
    },

    /**
     * Clears all fields in the form
     */
    clearForm() {
      Object.keys(this.past_diagnosis).forEach(key => {
        this.past_diagnosis[key] = "";
      });
    },

    /**
     * Resets the form
     */
    resetRow() {
      this.clearForm();
      this.past_diagnosis_edit = false;
    },

    /**
     * Returns the typeahead limit based on doctor's history
     */
    limitTypehead() {
      const history = this.doctorHistory?.past_diagnosis;
      return history?.length || DEFAULT_OPTIONS_LIMIT;
    },

    /**
     * Prepends doctor's history items to the typeahead options
     */
    getTypeheadHistory(resArr) {
      const history = this.doctorHistory?.past_diagnosis;
      if (!history?.length) return resArr;
      return [...history, ...resArr];
    },

    /**
     * Fetches doctor's diagnosis history and populates typeahead options
     */
    async getHistory() {
      if (!this.activeDoctor?.id) return;

      try {
        const resHistory = await this.$API.getDoctorHistory(
          this.activeDoctor.id
        );
        if (resHistory) this.doctorHistory = resHistory;

        // Fetch typeahead options - uses same endpoint as current diagnosis
        const diagnosisRes = await this.$API.getTypehead(
          "current_new_diagnosis"
        );

        // Process diagnosis options
        const diagnosisTmp = diagnosisRes.map(r => r.diagnosis);
        this.past_diagnosis_options = [
          ...new Set(this.getTypeheadHistory(diagnosisTmp))
        ];
      } catch (error) {
        console.error("Failed to fetch doctor history:", error);
      }
    }
  },
  watch: {
    activeDoctor: {
      handler() {
        this.getHistory();
      },
      immediate: true
    },

    /**
     * Auto-fill diagnosis number from name
     */
    "past_diagnosis.diagnosis_name"(val) {
      this.past_diagnosis.diagnosis_number = val.substring(0, val.indexOf(" "));
    }
  },
  mounted() {
    // Open section if past_diagnosis or background_diagnosis has content in edit mode
    if (
      this.isEditMode &&
      (this.surgery.past_diagnosis?.length || this.surgery.background_diagnosis)
    ) {
      this.isOpen = true;
    }
  }
};
</script>
